import api from "../../../services/api";



export interface EcommTopSelling {
    sku: string;
    title: string;
    image_src: string | null;
    sale_count: number;
    total_quantity: number;
    total_revenue: number;
    avg_price: number;
}


export interface EcommTopSellingParams {
    month: string;     // e.g., "2025-04"
    limit?: number;    // optional, defaults handled server-side if needed
}

export const getEcommTopSelling = async (
    params: EcommTopSellingParams
): Promise<EcommTopSelling[]> => {
    const response = await api.get('/api/shopify/top_selling_products', { params });
    return response.data.top_selling_products;
};
